<template>
  <v-dialog
    :value="open"
    :persistent="true"
    max-width="450"
    overlay-opacity="0.35"
    @input="onClose"
  >
    <v-card
      class="pa-6"
      rounded="lg"
      elevation="8"
      style="min-width: 400px;"
    >
      <v-card-title
        class="pa-0 mb-4 text-center modal-title"
        style="font-size: 18px; font-weight: 600; color: #212121;"
      >
        {{ $t('Assumptions.EditAssumptions.SaveAssumptionsModal.Title') }}
      </v-card-title>

      <v-card-text class="pa-0 mb-6 d-flex justify-center">
        <v-text-field
          v-model="assumptionName"
          :error-messages="serverErrorMessages['name']"
          :placeholder="$t('Assumptions.EditAssumptions.SaveAssumptionsModal.Placeholder')"
          outlined
          dense
          hide-details="auto"
          style="max-width: 320px; width: 100%;"
        />
      </v-card-text>

      <v-card-actions class="pa-0">
        <v-btn
          class="cancel-btn flex-grow-1"
          depressed
          height="40"
          @click="onClose"
        >
          {{ $t('Assumptions.EditAssumptions.SaveAssumptionsModal.Cancel') }}
        </v-btn>
        <v-btn
          class="save-btn flex-grow-1"
          depressed
          height="40"
          :disabled="!assumptionName.trim()"
          :loading="isSaving"
          @click="handleSave"
        >
          {{ $t('Assumptions.EditAssumptions.SaveAssumptionsModal.Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api/Api'

export default {
  name : 'SaveAssumptionsModal',
  props: {
    open: {
      type   : Boolean,
      default: false
    },
    onClose: {
      type    : Function,
      required: true
    },
    onSave: {
      type    : Function,
      required: true
    },
    isSaving: {
      type   : Boolean,
      default: false
    },
    defaultName: {
      type   : String,
      default: ''
    }
  },
  dataStore: {
    ActiveEveAnalysis: 'RiskInterestRate.ActiveEveAnalysis'
  },
  data () {
    return {
      assumptionName     : '',
      isCheckingName     : false,
      serverErrorMessages: {
        name: []
      }
    }
  },
  watch: {
    open (newVal) {
      if (newVal) {
        this.assumptionName = this.defaultName || ''
      }
    },

    assumptionName () {
      if (this.serverErrorMessages?.name?.length) {
        this.$set(this.serverErrorMessages, 'name', null)
      }
    }
  },
  methods: {
    async checkIfNameExists () {
      this.$set(this.serverErrorMessages, 'name', null)

      this.isCheckingName = true
      try {
        const response = await API.Resource.InterestRate.ExistsBankAnalysisByName(
          this.user.selectedAccountId,
          (this.assumptionName || '').trim()
        )
        const exists = API.responseData(response)?.existsBankAnalysisByName

        if (exists) {
          this.$set(this.serverErrorMessages, 'name', [this.$t('Assumptions.EditAssumptions.SaveAssumptionsModal.Duplicate')])
          return true
        }
        return false
      } finally {
        this.isCheckingName = false
      }
    },

    async handleSave () {
      const name = this.assumptionName.trim()
      const draftName = this.defaultName.trim()
      if (name === draftName) {
        this.onSave(name)
      } else {
        if (await this.checkIfNameExists()) {
          return
        }
        if (this.assumptionName.trim()) {
          this.onSave(this.assumptionName.trim())
        }
      }
    }
  }
}
</script>

<style scoped>
.modal-title {
  text-align: center !important;
  justify-content: center !important;
  display: flex !important;
  width: 100% !important;
}

.cancel-btn {
  background-color: #F5F5F5 !important;
  color: #212121 !important;
  border: none !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  margin-right: 8px;
}

.cancel-btn:hover {
  background-color: #EEEEEE !important;
}

.save-btn {
  background-color: #4CAF50 !important;
  color: #FFFFFF !important;
  border: none !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  text-transform: none !important;
}

.save-btn:hover {
  background-color: #45A049 !important;
}

.save-btn:disabled {
  background-color: #E0E0E0 !important;
  color: #9E9E9E !important;
}
</style>
